import Head from 'next/head';
import { useRouter } from 'next/router';
import { DEFAULT_LOCALE, PUBLIC_HOST } from '@config/index';

type PropsType = {
  currentUrl?: string;
};

const SelfCanonicalLink = ({ currentUrl = undefined }: PropsType) => {
  const { locale, asPath } = useRouter();
  const url = new URL(asPath, PUBLIC_HOST);
  const pathWithoutQuery = url.pathname;
  const path =
    currentUrl ?? `${PUBLIC_HOST}${locale !== DEFAULT_LOCALE ? `/${locale}${pathWithoutQuery}` : pathWithoutQuery}`;

  return (
    <Head>
      <link rel="canonical" href={path} />
    </Head>
  );
};

export default SelfCanonicalLink;
